import api, { GetApiReturn, GetApiReturnError, ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { ReadTipoGastoDto, CreateTipoGastoDto, UpdateTipoGastoDto } from '@/api.types';

export async function GetTipoGastos(skip: number, take: number) {
  return api
    .get(Endpoints.TIPO_GASTO, { params: { skip: skip, take: take } })
    .then((response) => {
      return GetApiReturn<ReadTipoGastoDto>(response.data as Array<ReadTipoGastoDto>);
    })
    .catch((error) => {
      ValidateAxiosError<ReadTipoGastoDto>(error, 'Falha ao listar Tipos de Gasto.');
      return GetApiReturnError<ReadTipoGastoDto>();
    });
}

export async function GetTipoGasto(id: number) {
  return api
    .get<ReadTipoGastoDto>(Endpoints.TIPO_GASTO + '/' + id)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return ValidateAxiosError<ReadTipoGastoDto>(error, 'Falha ao buscar o Tipo de Gasto.' + id);
    });
}

export async function SetTipoGasto(tipoGasto: CreateTipoGastoDto | UpdateTipoGastoDto) {
  if (tipoGasto.id !== null && tipoGasto.id != undefined && tipoGasto.id > 0) {
    return api
      .put(Endpoints.TIPO_GASTO + '/' + tipoGasto.id, tipoGasto as UpdateTipoGastoDto)
      .then(() => {
        return 'Tipo de gasto atualizado.';
      })
      .catch((error) => {
        return ValidateAxiosError<string>(
          error,
          'Falha ao atualizar o Tipo de Gasto.',
        );
      });
  } else {
    return api
      .post(Endpoints.TIPO_GASTO, tipoGasto as CreateTipoGastoDto)
      .then(() => {
        return 'Tipo de gasto cadastrado.';
      })
      .catch((error) => {
        return ValidateAxiosError<string>(
          error,
          'Falha ao cadastrar o Tipo de Gasto.',
        );
      });
  }
}

export async function DeleteTipoGasto(id: number) {
  return api
    .delete(Endpoints.TIPO_GASTO + '/' + id)
    .then(() => {
      return 'Tipo de gasto removido.';
    })
    .catch((error) => {
      return ValidateAxiosError<string>(error, 'Falha ao remover Tipo de Gasto.');
    });
}